import React, { Component } from "react";
import { Link } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../../config';
import {
  getProjectLists,
  removeProjectList,
  updateProjectList,
} from "../../../../services/projectService";
import CustomLoader from "../../../common/Loader";
import CreateNewDialog from "../CreateNewDialog";
import ProjectListActionMenu from "./ListActionMenu";
import { logActivity } from '../../../../services/utilService';

class ProjectLists extends Component {
  state = {
    Project_ID: this.props.Project_ID,
    Project_Lists: [],
    loading: true,
  };

  async componentDidMount() {
    const { data: Project_Lists } = await getProjectLists(
      this.props.Project_ID
    );
    this.setState({ Project_Lists });
    this.setState({ loading: false });
  }

  handleNewList = async (List_Name) => {
    const { Project_ID } = this.state;
    const { data } = await updateProjectList(Project_ID, 0, List_Name);

    if (data.includes("Error")) {
      toaster('error', data);
      logActivity('/projectSettings', 'PROJECT_LIST_CREATE_FAILED');
    } else {
      toaster('success', 'New project list created');
      logActivity('/projectSettings', 'PROJECT_LIST_CREATE_SUCCESS');
      const { data: Project_Lists } = await getProjectLists(Project_ID);
      this.setState({ Project_Lists });
    }
  };

  handleDelete = async (Record_ID) => {
    const { data } = await removeProjectList(Record_ID);
    if (data.includes("Error")) {
      toaster('error', data);
      logActivity('/projectSettings', 'PROJECT_LIST_DELETE_FAILED');
    } else {
      let Project_Lists = this.state.Project_Lists.filter(
        (pf) => pf.Record_ID !== Record_ID
      );
      this.setState({ Project_Lists });
      toaster('success', 'Project list removed');
      logActivity('/projectSettings', 'PROJECT_LIST_DELETE_SUCCESS');
    }
  };

  render() {
    if (this.state.loading) {
      return <CustomLoader loading={this.state.loading} />;
    }

    const { Project_Lists } = this.state;

    return (
      <React.Fragment>
        <CreateNewDialog handleNew={this.handleNewList} Type="List" />
        <table className="table table-hover table-borderless">
          <thead className="border-bottom">
            <tr>
              <th>List ID</th>
              <th>List Name</th>
              <th>Owner</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {Project_Lists.map((list) => (
              <tr key={"projectList" + list.List_ID} className="border-bottom">
                <td>{list.List_ID}</td>
                <td>
                  <Link
                    to={{
                      pathname: "/listSettings/",
                      List_ID: list.List_ID,
                      List_Name: list.List_Name,
                      Project_ID: this.props.Project_ID,
                    }}
                    style={{ textDecoration: "None" }}
                  >
                    {list.List_Name}
                  </Link>
                </td>
                <td>{list.Created_By}</td>
                <td>
                  <ProjectListActionMenu
                    key={"listActions" + list.List_ID}
                    list={list}
                    handleDelete={this.handleDelete}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <ToastContainer/>
      </React.Fragment>
    );
  }
}

export default ProjectLists;
